import { httpClient } from "@/services";
import { workOrdersListHeader } from "@/constants/defaultHeader";
import requestKeys from "@/constants/requestKeys";

export default {
	state: {
		workOrdersList: [],
		workOrdersFilter: null,
		workOrdersFilterDefault: null,
		workOrders: null,
		deleteWorkOrdersList: [],
		deleteInvoiceList: [],
		workOrdersPreloader: false,
		workOrdersSettingsDefault: [],
		workOrdersSettings: [],
		workOrdersHeaders: [],
	},
	mutations: {
		updateWorkOrdersList(state, { filter, list, settings, isDelete }) {
			if (!isDelete) state.workOrdersList = list;
			if (filter) state.workOrdersFilter = filter;
			if (settings.length > 0) {
				state.workOrdersSettingsDefault = settings;
				state.workOrdersSettings = settings.map(item => ({ ...item }));
				state.workOrdersHeaders = [];
				settings.map(item => {
					if (item.settings) {
						state.workOrdersHeaders.push(item);
					}
				});
			} else {
				state.workOrdersSettingsDefault = workOrdersListHeader;
				state.workOrdersSettings = workOrdersListHeader.map(item => ({ ...item }));
				state.workOrdersHeaders = [];
				workOrdersListHeader.map(item => {
					if (item.settings) {
						state.workOrdersHeaders.push(item);
					}
				});
			}
		},

		updateWorkOrdersPreloader(state, payload) {
			state.workOrdersPreloader = payload;
		},
		updateWorkOrdersListDefault(state, { filter }) {
			filter['filter_truck_id'] = [];
			state.workOrdersFilterDefault = filter;
		},
		updateWorkOrders(state, payload) {
			state.workOrders = payload;
		},
		updateWorkOrdersDelete(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteWorkOrdersList = [];
			} else {
				state.deleteWorkOrdersList.push(id);
			}
		},
		updateInvoiceList(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteInvoiceList = [];
			} else {
				state.deleteInvoiceList.push(id);
			}
		},
		updateAddWorkOrdersList(state, { row, id }) {
			const idx = state.workOrdersList.findIndex(item => item.id === id);

			if (row.status === "Canceled") {
				state.workOrdersList.splice(idx, 1);
			} else if (idx === -1) {
				state.workOrdersList.unshift(row);
			} else {
				state.workOrdersList.splice(idx, 1, row);
			}
		},
		updateListAfterRemoveItem(state, id) {
			const idx = state.workOrdersList.findIndex(item => item.id === id);
			if (idx !== -1) state.workOrdersList.splice(idx, 1);
		},
		updateClearWOFilter(state) {
			state.workOrdersFilter = null;
			state.workOrdersFilterDefault = null;
		}
	},
	actions: {
		onClearWOFilter({ commit }) {
			commit('updateClearWOFilter');
		},
		onWorkOrdersPreloader({ commit }, value) {
			commit('updateWorkOrdersPreloader', value);
		},
		async onWorkOrdersStart({ commit }) {
			try {
				const { data } = await httpClient.get('/work-order/start');
				if (data && !data.status) {
					commit('updateWorkOrdersList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.WORK_ORDERS, defaultHeader: workOrdersListHeader });
					commit('updateWorkOrdersListDefault', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrders({ commit, dispatch }, isDelete) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/work-order');
				if (data && !data.status) {
					data.isDelete = isDelete;
					commit('updateWorkOrdersList', data);
					commit('updateWorkOrdersListDefault', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrdersEdit({ commit }, id) {
			try {
				const { data } = await httpClient.get(`/work-order/${ id }/edit`);
				if (data && !data.status) {
					commit('updateWorkOrders', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrdersCreate({ commit }, id) {
			const url = id ? `/work-order/create?customer_id=${ id }` : "/work-order/create";
			try {
				const { data } = await httpClient.get(url);
				if (data && !data.status) {
					if (id) {
						return data;
					}
					commit('updateWorkOrders', data);

				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrdersSave({ commit }, { values, id }) {
			const typeOfRequest = id ? 'put' : 'post';
			const url = id ? `/work-order/${ id }` : '/work-order';
			try {
				const { data } = await httpClient[typeOfRequest](url, values);

				if (data) {
					const { status, error, row } = data;
					if (!error) commit('updateAddWorkOrdersList', { row, id });
					return { status, error };
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrdersFilter({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/work-order/list', payload);
				if (data && !data.status) {
					commit('updateWorkOrdersList', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onRemoveWorkOrder({ dispatch, commit }, id) {
			try {
				const { data } = await httpClient.delete(`/work-order/${ id }`);
				if (data && data.status) {
					commit('updateListAfterRemoveItem', id);
					dispatch('onWorkOrders', true);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrderComments({ dispatch }, id) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.get(`/work-order/description/${ id }`);
				if (data && !data.status) {
					dispatch("actionPreloader", false);
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onWorkOrdersDelete({ state }) {
			if (state.deleteWorkOrdersList.length) await httpClient.post(`/work-order/destroyDescription`, { ids: state.deleteWorkOrdersList });
		},
		async onInvoiceDelete({ state }) {
			if (state.deleteInvoiceList.length) await httpClient.post(`/work-order/destroyInvoice`, { ids: state.deleteInvoiceList });
		},
		getWorkOrdersDelete({ commit }, { id, isDelete }) {
			commit('updateWorkOrdersDelete', { id, isDelete });
		},
		getInvoiceDelete({ commit }, { id, isDelete }) {
			commit('updateInvoiceList', { id, isDelete });
		},
		async getDispatcherList(context, values) {
			const { data } = await httpClient.post(`/work-order/date`, { ...values });
			if (data && data.status) return data['dispatch_request'];
		}
	},
	getters: {
		workOrdersList: s => s.workOrdersList,
		workOrdersFilter: s => s.workOrdersFilter,
		workOrders: s => s.workOrders,
		workOrdersFilterDefault: s => s.workOrdersFilterDefault,
		workOrdersPreloader: s => s.workOrdersPreloader,
		workOrdersSettingsDefault: s => s.workOrdersSettingsDefault,
		workOrdersSettings: s => s.workOrdersSettings,
		workOrdersHeaders: s => s.workOrdersHeaders,
	}
};
